import { render, staticRenderFns } from "./_index.vue?vue&type=template&id=03b2d6e3&scoped=true"
import script from "./_index.vue?vue&type=script&lang=js"
export * from "./_index.vue?vue&type=script&lang=js"
import style0 from "./_index.vue?vue&type=style&index=0&id=03b2d6e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b2d6e3",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActivityCard: require('/workspace/components/ActivityCard.vue').default,PackageCard: require('/workspace/components/PackageCard.vue').default,PlaceCard: require('/workspace/components/PlaceCard.vue').default,RestaurantCard: require('/workspace/components/RestaurantCard.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default})
